export default __webpack_public_path__ + "static/media/pagenotfound.87049462.jpg";